var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user-detail-nav-wrapper"},[_c('a',{attrs:{"href":""},on:{"click":_vm.goToUserDetail}},[_vm._v(_vm._s(_vm.$t("users.title")))]),_c('span',{staticClass:"breadcrum-center-value"},[_vm._v(_vm._s(" / " + _vm.user.name + " " + _vm.user.lastName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }